<script setup>
defineProps({
  title: {
    type: String,
    default: () => '',
  },
  value: {
    type: String,
    default: () => '',
  },
  icon: {
    type: Object,
    default: () => {},
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div class="mark-card" :class="`mark-card--${backgroundColor}`">
    <div class="mark-card__top">
      <NuxtImg
        v-if="icon?.src"
        :src="icon?.src"
        :alt="icon?.alt"
        :height="icon.height"
        :width="icon.width"
        class="mark-card__icon"
        loading="lazy"
      />
      <p v-if="value" class="mb-0 mark-card__value h5" v-html="value"></p>
    </div>
    <div
      v-if="title"
      class="mark-card__title body-3-regular"
      v-html="title"
    ></div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.mark-card {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 8px;
  &__top {
    align-items: center;
    min-height: 104px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: 26px;
    @include media-breakpoint-up(sm) {
      min-height: 139px;
      padding-top: 35px;
    }
    @include media-breakpoint-up(md) {
      min-height: 124px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 8);
      @include responsive-spacing(gap, 12);
      @include responsive-spacing(min-height, 124);
      @include responsive-spacing(padding-top, 35);
    }
  }
  &--white {
    #{$parent} {
      &__top {
        background-color: $gray;
      }
    }
  }
  &--black {
    #{$parent} {
      &__top {
        background-color: rgba($surface-container-opacity, 0.5);
      }
    }
  }
  &--gray {
    #{$parent} {
      &__top {
        background-color: $white;
      }
    }
  }
}
</style>
